/* use Uppercase for keys */
export enum TypeBlock {
  FULFILLED_SYSTEM = 'Réalisé',
  FULFILLED  = 'Réalisé validé',
  INCOHERENCE = 'Réalisé validé',
  PLANNED   = 'Prévu',
  FULFILLED_INCOHERENCE = 'Réalisé validé',
}
export enum TypeBlockLabel {
  FULFILLED_SYSTEM = 'REALIZED',
  FULFILLED  = 'REALIZED_VALIDATED',
  INCOHERENCE = 'REALIZED_VALIDATED',
  PLANNED   = 'PLANNED',
  REALIZED_VALIDATED = "REALIZED_VALIDATED",
  REALIZED = 'REALIZED',
  FULFILLED_INCOHERENCE = 'REALIZED_VALIDATED',
}



// WEBPACK FOOTER //
// ./src/app/model/TypeBlock.ts